function isDrayNowHost() {
  // Check the build-time global first (vite.config.mjs `define` injects it)
  /* global APPLICATION_THEME */
  if (typeof APPLICATION_THEME !== 'undefined') {
    return APPLICATION_THEME === 'draynow'
  }

  // Fallback to hostname detection (for production deployments)
  return (
    location.hostname.endsWith('.draynow.localhost') ||
    location.hostname.endsWith('.draynow.com')
  )
}

let isDrayNow = isDrayNowHost()

function refreshTheme() {
  isDrayNow = isDrayNowHost()
}

const drayNowOrderCategories = [
  'open',
  'pending',
  'tendered',
  'in_progress',
  'finished',
  'closed',
  'canceled',
]
const modalViewOrderCategories = [
  'alerts',
  'drafts',
  'pending_carrier',
  'pending_driver',
  'tendered',
  'in_progress',
  'finished',
  'closed',
  'canceled',
]

function getOrdersCategories() {
  return isDrayNowHost() ? drayNowOrderCategories : modalViewOrderCategories
}

const drayNowOrderStatuses = {
  draft: 'Draft',
  published: 'Tendered to DrayNow',
  reopened: 'Reopened',
  carrierRequested: 'Pending - Carrier Requested',
  tenderedNotStartable: 'Driver Assigned - Not Startable',
  tenderedStartable: 'Driver Assigned - Ready',
  inProgress: 'In Progress',
  unapprovedAccessorials: 'Finished - Unapproved Accessorials',
  finished: 'Finished',
  closed: 'Closed',
  canceled: 'Canceled',
}

const modalViewOrderStatuses = {
  draft: 'Draft Tender',
  pending_carrier: 'Tender pending',
  pending_driver: 'Pending Driver Acceptance',
  tenderedNotStartable: 'Tendered - Not Startable',
  tenderedStartable: 'Tendered - Ready',
  inProgress: 'In Progress',
  unapprovedAccessorials: 'Finished - Unapproved Accessorials',
  finished: 'Finished',
  closed: 'Closed',
  canceled: 'Canceled',
}
function getOrderStatuses() {
  return isDrayNowHost() ? drayNowOrderStatuses : modalViewOrderStatuses
}

const drayNowFilterMeta = {
  overview: { icon: '', title: 'Overview' },
  search: { icon: '', title: 'Search' },
  alerts: { icon: 'warning circle', title: 'Alerts' },
  drafts: { icon: 'pencil', title: 'Drafts' },
  open: {
    icon: 'inbox',
    title: 'Tendered to DrayNow',
    displayPredicate: (perms) => perms.includes('canViewOpenMarketplace'),
  },
  pending: {
    icon: 'hourglass half',
    title: 'Pending',
    displayPredicate: (perms) => perms.includes('canViewOpenMarketplace'),
  },
  tendered: { icon: 'check circle outline', title: 'Driver Assigned' },
  in_progress: { icon: 'truck', title: 'In Progress' },
  finished: { icon: 'flag checkered', title: 'Finished' },
  closed: { icon: 'folder', title: 'Closed' },
  canceled: { icon: 'remove', title: 'Canceled' },
}

const modalViewFilterMeta = {
  overview: { icon: '', title: 'Overview' },
  search: { icon: '', title: 'Search' },
  alerts: { icon: 'warning circle', title: 'Alerts' },
  drafts: { icon: 'pencil', title: 'Draft Tender' },
  pending_carrier: {
    icon: 'hourglass half',
    title: 'Tender Pending',
    displayPredicate: (perms) => perms.includes('canViewOpenMarketplace'),
  },
  pending_driver: {
    icon: 'hourglass half',
    title: 'Pending Driver Acceptance',
  },
  tendered: { icon: 'check circle outline', title: 'Tendered' },
  in_progress: { icon: 'truck', title: 'In Progress' },
  finished: { icon: 'flag checkered', title: 'Finished' },
  closed: { icon: 'folder', title: 'Closed' },
  canceled: { icon: 'remove', title: 'Canceled' },
}

function getFilterMeta() {
  return isDrayNowHost() ? drayNowFilterMeta : modalViewFilterMeta
}

const modalViewFeatureFlags = {
  admin_markets: false,
  admin_notifications: false,
  can_assign_driver_on_in_progress: true,
  carrier_price_override: false,
  data_table_waitlist: false,
  data_table_carrier_price: false,
  data_table_market: false,
  data_table_price_button: false,
  data_table_street_turn_button: false,
  data_table_total_prices: false,
  help: false,
  international_delivery_display: true,
  bobtail_display: true,
  lanes: false,
  market_selector: false,
  sales_order: false,
  street_turn_management: false,
  trigger_invoicing: false,
  vendor_bill: false,
  alternative_order_type_naming: true,
  remove_driver: true,
  intercom: true,
}

const drayNowFeatureFlags = {
  admin_markets: true,
  admin_notifications: true,
  can_assign_driver_on_in_progress: false,
  carrier_price_override: true,
  data_table_waitlist: true,
  data_table_carrier_price: true,
  data_table_market: true,
  data_table_price_button: true,
  data_table_street_turn_button: true,
  data_table_total_prices: true,
  help: true,
  international_delivery_display: false,
  bobtail_display: false,
  lanes: true,
  market_selector: true,
  sales_order: true,
  street_turn_management: true,
  trigger_invoicing: true,
  vendor_bill: true,
  alternative_order_type_naming: false,
  remove_driver: false,
  intercom: true,
}

function getFeatureFlags() {
  return isDrayNowHost() ? drayNowFeatureFlags : modalViewFeatureFlags
}

export {
  isDrayNow,
  isDrayNowHost,
  refreshTheme,
  getOrdersCategories,
  getFilterMeta,
  getOrderStatuses,
  getFeatureFlags,
}
